import { useEffect, useState } from 'react';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../../firebase';

const DEFAULTS = {
  mediaText: 'KTS鹿児島テレビ「SUPER EIGHT 安田章大の人生って最高だ」にてタイトル文字制作を担当。',
  links: [
    { label: 'Instagram', handle: '@koureiansaiun', url: 'https://www.instagram.com/koureiansaiun' },
    { label: 'Facebook', handle: '書 創作 虹嶺庵 彩雲', url: 'https://www.facebook.com' },
    { label: 'Creema', handle: 'ハンドメイド作品の販売', url: 'https://www.creema.jp' },
  ],
};

function linksToText(links) {
  return links.map((l) => `${l.label}|${l.handle}|${l.url}`).join('\n');
}

function textToLinks(text) {
  return text
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line) => {
      const [label, handle, url] = line.split('|');
      return { label: (label || '').trim(), handle: (handle || '').trim(), url: (url || '').trim() };
    });
}

export default function AdminActivities() {
  const [mediaText, setMediaText] = useState(DEFAULTS.mediaText);
  const [linksText, setLinksText] = useState(linksToText(DEFAULTS.links));
  const [saving, setSaving] = useState(false);
  const [status, setStatus] = useState('');

  useEffect(() => {
    getDoc(doc(db, 'siteContent', 'activities')).then((snap) => {
      if (snap.exists()) {
        const data = snap.data();
        setMediaText(data.mediaText ?? DEFAULTS.mediaText);
        setLinksText(linksToText(data.links ?? DEFAULTS.links));
      }
    });
  }, []);

  const onSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    setStatus('');
    try {
      await setDoc(doc(db, 'siteContent', 'activities'), {
        mediaText,
        links: textToLinks(linksText),
      }, { merge: true });
      setStatus('保存しました。');
    } catch (err) {
      setStatus('保存に失敗しました。');
    } finally {
      setSaving(false);
    }
  };

  return (
    <form className="admin-panel admin-form" onSubmit={onSave}>
      <label className="admin-form__field">
        <span>メディア出演・お知らせ</span>
        <textarea rows={4} value={mediaText} onChange={(e) => setMediaText(e.target.value)} />
      </label>

      <label className="admin-form__field">
        <span>SNS・販売リンク（1行ずつ「表示名｜説明｜URL」の形式。例：Instagram｜@koureiansaiun｜https://www.instagram.com/koureiansaiun）</span>
        <textarea rows={6} value={linksText} onChange={(e) => setLinksText(e.target.value)} />
      </label>

      <button className="admin-form__submit" type="submit" disabled={saving}>
        {saving ? '保存中...' : '保存する'}
      </button>

      {status && <p className="admin-form__status">{status}</p>}
    </form>
  );
}
